/* Personalizador propio de famgraving.com (19-oct-2026), sin Globo.
   Lee el JSON del metafield custom.personalizer que imprime snippets/fg-personalizer.liquid:
   tarjetas con los diseños, vista previa del diseño elegido (según la variante, p. ej. la
   forma), los campos de ese diseño y una casilla de confirmación.
   Todo viaja como line item properties en el formulario del botón (atributo form=):
   properties[Design], properties[<prop de cada campo>], properties[_Spelling checked].

   30-oct-2026 (salida de Globo): tipos de campo además de texto —
     file   → sube la foto con el formulario (Shopify la guarda en cdn.shopify.com y la URL
              llega en la property de la orden). "accept": ".jpg,.jpeg,.png"
     check  → casilla ("text": lo que dice al lado). Marcada viaja como <prop> = "value" (Yes).
     select → lista ("options": ["A", {"v": "B", "price": "2.00", "addon": <variant id>}]).
   (casilla con "need_one": [props] → marcada pide al menos uno de esos campos)
   y para cualquiera: "prop" (nombre en la orden; si no, el label), "show_if": {"<prop>": ["valor"]}
   (oculto = no viaja ni se valida). Con un solo diseño sin imagen no se pintan tarjetas ni
   properties[Design].
   Cobro extra: una casilla u opción con "addon" (variante del producto oculto
   "Personalization add-on") y "price". Al agregar, entra primero la línea del cargo (misma
   cantidad) y la línea del producto lleva properties[_pz_fees] = "<variant>:1,…"; el guardia
   snippets/fg-pz-fee-guard.liquid mantiene el cargo cuadrado con el carrito.

   2-nov-2026 (Santa trays, María): tipo "choice" = tarjetas con foto, una sola elegida
   ("options": [{"v": "…", "image": "asset:foto.jpg" | url, "price", "addon"}], la primera va
   marcada) y "show_if_variant": ["Small"] → el campo solo sale si alguna opción de la variante
   elegida contiene ese texto (se recalcula al cambiar la variante). "asset:<archivo>" = archivo
   de assets/ del theme. Si ningún campo queda visible se esconde la caja entera. */
(function () {
  'use strict';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function money(p) { var n = parseFloat(p); return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var cfg, variants;
    try {
      cfg = JSON.parse(root.querySelector('[data-fgpz-config]').textContent);
      variants = JSON.parse(root.querySelector('[data-fgpz-variants]').textContent);
    } catch (e) { return; }
    var designs = (cfg && cfg.designs) || [];
    if (!designs.length) return;
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var current = 0;
    var values = {};   // lo escrito se conserva por prop al cambiar de diseño
    var inputs = [];   // [{f, wrap, inp}] del diseño actual
    var noCards = designs.length === 1 && !designs[0].image && !designs[0].images;
    var assetBase = (root.getAttribute('data-asset-base') || '').replace(/[^/]*$/, '');
    function src(u) { return u && u.indexOf('asset:') === 0 ? assetBase + u.slice(6) : u; }

    function propOf(f) { return f.prop || f.label; }

    // ---- estructura ----
    root.appendChild(el('p', 'fgpz__title', cfg.title || 'Personalize it'));
    var cards = el('div', 'fgpz__cards');
    cards.setAttribute('role', 'radiogroup');
    var prev = el('figure', 'fgpz__preview');
    var prevImg = el('img');
    prevImg.alt = '';
    prevImg.loading = 'lazy';
    var cap = el('figcaption', 'fgpz__caption');
    prev.appendChild(prevImg);
    prev.appendChild(cap);
    if (!noCards) {
      root.appendChild(el('p', 'fgpz__step', 'Choose your design'));
      root.appendChild(cards);
      root.appendChild(prev);
      root.appendChild(el('p', 'fgpz__step', cfg.fields_title || 'Add your text'));
    } else if (cfg.fields_title) {
      root.appendChild(el('p', 'fgpz__step', cfg.fields_title));
    }
    var fieldsBox = el('div', 'fgpz__fields');
    root.appendChild(fieldsBox);

    var design = el('input');
    design.type = 'hidden';
    design.name = 'properties[Design]';
    design.setAttribute('form', formId);
    if (noCards) design.disabled = true;
    root.appendChild(design);

    var fees = el('input');
    fees.type = 'hidden';
    fees.name = 'properties[_pz_fees]';
    fees.setAttribute('form', formId);
    fees.disabled = true;
    root.appendChild(fees);

    var confirmBox = null, confirmIn = null;
    if (cfg.confirm) {
      confirmBox = el('label', 'fgpz__confirm');
      confirmIn = el('input');
      confirmIn.type = 'checkbox';
      confirmIn.name = 'properties[_Spelling checked]';
      confirmIn.value = 'Yes';
      confirmIn.setAttribute('form', formId);
      confirmBox.appendChild(confirmIn);
      confirmBox.appendChild(el('span', null, cfg.confirm));
      root.appendChild(confirmBox);
      confirmIn.addEventListener('change', function () { if (confirmIn.checked) err(''); });
    }
    var errBox = el('p', 'fgpz__error');
    errBox.setAttribute('role', 'alert');
    root.appendChild(errBox);
    function err(t) { errBox.textContent = t; errBox.hidden = !t; }
    err('');

    // ---- variante actual → imagen del diseño ----
    function variantOptions() {
      var f = document.getElementById(formId);
      var idIn = f && f.querySelector('input[name="id"]');
      var id = idIn ? String(idIn.value) : (new URLSearchParams(location.search).get('variant') || '');
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i].options;
      return variants.length ? variants[0].options : [];
    }
    function imageFor(d) {
      if (d.images) {
        var opts = variantOptions();
        for (var i = 0; i < opts.length; i++) if (d.images[opts[i]]) return d.images[opts[i]];
        var k = Object.keys(d.images);
        if (k.length) return d.images[k[0]];
      }
      return d.image || '';
    }

    designs.forEach(function (d, i) {
      var b = el('button', 'fgpz__card');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      var im = el('img');
      im.alt = d.name;
      im.loading = 'lazy';
      b.appendChild(im);
      b.appendChild(el('span', 'fgpz__card-name', d.name));
      b.addEventListener('click', function () { select(i); });
      cards.appendChild(b);
    });

    function paintImages() {
      if (noCards) return;
      var bs = cards.querySelectorAll('.fgpz__card');
      designs.forEach(function (d, i) {
        var u = imageFor(d);
        var im = bs[i].querySelector('img');
        if (u && im.getAttribute('src') !== u) im.src = u;
      });
      var u2 = imageFor(designs[current]);
      if (u2 && prevImg.getAttribute('src') !== u2) prevImg.src = u2;
      prevImg.alt = 'Preview: ' + designs[current].name;
      prev.hidden = !u2;
    }

    function updateCaption() {
      if (noCards) return;
      var d = designs[current];
      var typed = inputs.filter(function (x) { return (x.f.type || 'text') === 'text' && !x.inp.disabled; })
        .map(function (x) { return (values[propOf(x.f)] || '').trim(); }).filter(Boolean);
      cap.textContent = '';
      cap.appendChild(el('strong', null, 'Your design: '));
      cap.appendChild(document.createTextNode(d.name));
      if (typed.length) {
        cap.appendChild(el('br'));
        cap.appendChild(el('strong', null, 'Your text: '));
        cap.appendChild(document.createTextNode(typed.join(' / ')));
      }
    }

    // Condiciones: show_if {"<prop>": [valores]}; oculto = deshabilitado (no viaja ni se valida)
    function conds() {
      inputs.forEach(function (x) {
        var on = !x.f.show_if || Object.keys(x.f.show_if).every(function (k) {
          return x.f.show_if[k].indexOf(values[k] || '') >= 0;
        });
        if (on && x.f.show_if_variant) {
          var vo = variantOptions().join(' | ').toLowerCase();
          on = x.f.show_if_variant.some(function (t) { return vo.indexOf(String(t).toLowerCase()) >= 0; });
        }
        x.wrap.hidden = !on;
        x.inp.disabled = !on;
        if (!on) x.wrap.classList.remove('is-missing');
      });
      root.hidden = noCards && !confirmIn && inputs.length > 0 && inputs.every(function (x) { return x.wrap.hidden; });
      updateCaption();
    }

    function buildFields() {
      var d = designs[current];
      fieldsBox.innerHTML = '';
      inputs = [];
      (d.fields || []).forEach(function (f, j) {
        var type = f.type || 'text';
        var prop = propOf(f);
        var wrap = el('div', 'fgpz__field fgpz__field--' + type);
        var id = formId + '-fgpz-' + j;
        var inp, cnt = null;
        if (type === 'check') {
          var lab0 = el('label', 'fgpz__check');
          inp = el('input');
          inp.type = 'checkbox';
          inp.value = f.value || 'Yes';
          inp.checked = values[prop] === inp.value;
          lab0.appendChild(inp);
          var t = el('span', 'fgpz__check-text', f.text || f.label);
          if (f.price) t.appendChild(el('span', 'fgpz__price', ' +' + money(f.price)));
          lab0.appendChild(t);
          wrap.appendChild(lab0);
          if (f.help) wrap.appendChild(el('p', 'fgpz__help', f.help));
        } else if (type === 'choice') {
          wrap.appendChild(el('p', 'fgpz__label', f.label));
          if (f.help) wrap.appendChild(el('p', 'fgpz__help', f.help));
          // input oculto con el valor elegido: es el que viaja y el que mira addons()
          inp = el('input');
          inp.type = 'hidden';
          var grid = el('div', 'fgpz__choices');
          grid.setAttribute('role', 'radiogroup');
          var opts = f.options || [];
          var pick = function (k) {
            var o = opts[k];
            inp.value = o.v;
            if (o.addon) inp.setAttribute('data-addon', o.addon); else inp.removeAttribute('data-addon');
            grid.querySelectorAll('.fgpz__choice').forEach(function (c, m) {
              c.classList.toggle('is-on', m === k);
              c.setAttribute('aria-checked', m === k ? 'true' : 'false');
            });
          };
          opts.forEach(function (o, k) {
            var c = el('button', 'fgpz__choice');
            c.type = 'button';
            c.setAttribute('role', 'radio');
            if (o.image) { var ci = el('img'); ci.src = src(o.image); ci.alt = o.v; ci.loading = 'lazy'; c.appendChild(ci); }
            var cn = el('span', 'fgpz__choice-name', o.v);
            if (o.price) cn.appendChild(el('span', 'fgpz__price', ' +' + money(o.price)));
            c.appendChild(cn);
            c.addEventListener('click', function () { pick(k); upd(); });
            grid.appendChild(c);
          });
          var start = 0;
          opts.forEach(function (o, k) { if (o.v === values[prop]) start = k; });
          if (opts.length) pick(start);
          wrap.appendChild(grid);
          wrap.appendChild(inp);
        } else {
          var lab = el('label', 'fgpz__label', f.label);
          lab.htmlFor = id;
          if (f.required) { var s = el('span', 'fgpz__req', ' *'); s.setAttribute('aria-hidden', 'true'); lab.appendChild(s); }
          else lab.appendChild(el('span', 'fgpz__opt', ' (optional)'));
          wrap.appendChild(lab);
          if (f.help) wrap.appendChild(el('p', 'fgpz__help', f.help));
          if (type === 'select') {
            inp = el('select', 'fgpz__input fgpz__select');
            var o0 = el('option', null, f.placeholder || '-- Please select --');
            o0.value = '';
            inp.appendChild(o0);
            (f.options || []).forEach(function (o) {
              var v = o.v || o;
              var op = el('option', null, v + (o.price ? ' (+' + money(o.price) + ')' : ''));
              op.value = v;
              if (o.addon) op.setAttribute('data-addon', o.addon);
              inp.appendChild(op);
            });
            inp.value = values[prop] || f.default || '';
          } else if (type === 'file') {
            inp = el('input', 'fgpz__file');
            inp.type = 'file';
            inp.accept = f.accept || '.jpg,.jpeg,.png';
          } else {
            inp = el('input', 'fgpz__input');
            inp.type = 'text';
            inp.autocomplete = 'off';
            if (f.max) inp.maxLength = f.max;
            if (f.placeholder) inp.placeholder = f.placeholder;
            inp.value = values[prop] || '';
            if (f.max) cnt = el('span', 'fgpz__count');
          }
          inp.id = id;
          if (f.required) inp.required = true;
          var row = el('div', 'fgpz__row');
          row.appendChild(inp);
          if (cnt) row.appendChild(cnt);
          wrap.appendChild(row);
        }
        inp.name = 'properties[' + prop + ']';
        inp.setAttribute('form', formId);
        var x = { f: f, wrap: wrap, inp: inp };
        function upd() {
          if (type === 'check') values[prop] = inp.checked ? inp.value : '';
          else if (type === 'file') values[prop] = inp.files && inp.files.length ? inp.files[0].name : '';
          else values[prop] = inp.value;
          if (cnt) cnt.textContent = inp.value.length + '/' + f.max;
          if ((values[prop] || '').trim()) wrap.classList.remove('is-missing');
          conds();
        }
        if (type !== 'choice') inp.addEventListener(type === 'text' ? 'input' : 'change', upd);
        inputs.push(x);
        fieldsBox.appendChild(wrap);
        if (type !== 'file') {
          if (cnt) cnt.textContent = inp.value.length + '/' + f.max;
          values[prop] = type === 'check' ? (inp.checked ? inp.value : '') : inp.value;
        } else values[prop] = '';
      });
      conds();
    }

    function select(i) {
      current = i;
      design.value = designs[i].name;
      cards.querySelectorAll('.fgpz__card').forEach(function (b, k) {
        b.classList.toggle('is-on', k === i);
        b.setAttribute('aria-checked', k === i ? 'true' : 'false');
      });
      buildFields();
      paintImages();
      updateCaption();
      err('');
    }
    select(0);

    // La imagen depende de la variante (forma): se repinta cuando cambia.
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios, select[name="id"]')) setTimeout(function () { paintImages(); conds(); }, 60);
    });
    window.addEventListener('popstate', function () { setTimeout(function () { paintImages(); conds(); }, 60); });

    // Sin lo obligatorio o sin la casilla no se agrega al carrito (captura: antes que el theme).
    function valid() {
      var d = designs[current], miss = null, msg = '';
      inputs.forEach(function (x) {
        if (x.inp.disabled) return;
        var type = x.f.type || 'text', bad = false;
        if (type === 'file') {
          var file = x.inp.files && x.inp.files[0];
          bad = x.f.required && !file;
          if (file && file.size > 20 * 1024 * 1024) { bad = true; msg = 'Your photo is too large (max 20 MB). Please choose a smaller file.'; }
        } else bad = x.f.required && !(values[propOf(x.f)] || '').trim();
        x.wrap.classList.toggle('is-missing', bad);
        if (bad && !miss) {
          miss = x;
          if (!msg) msg = type === 'file' ? 'Please upload your ' + (x.f.what || 'photo') + '.' :
            type === 'select' ? 'Please choose "' + x.f.label + '".' :
            noCards ? 'Please fill in "' + x.f.label + '".' : 'Please add your text for "' + d.name + '".';
        }
      });
      // Casilla con "need_one": marcada, al menos uno de esos campos con texto (no se cobra en blanco)
      if (!miss) inputs.forEach(function (x) {
        if (miss || x.inp.disabled || (x.f.type || 'text') !== 'check' || !x.inp.checked || !x.f.need_one) return;
        if (x.f.need_one.some(function (p) { return (values[p] || '').trim(); })) return;
        miss = inputs.filter(function (y) { return x.f.need_one.indexOf(propOf(y.f)) >= 0; })[0] || x;
        miss.wrap.classList.add('is-missing');
        msg = 'Please add your text, or uncheck "' + (x.f.label || x.f.text) + '".';
      });
      if (miss) { err(msg); miss.wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); try { miss.inp.focus({ preventScroll: true }); } catch (e) {} return false; }
      if (confirmIn && !confirmIn.checked) { err('Please confirm that you checked the spelling.'); confirmBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); return false; }
      err('');
      return true;
    }

    // Cargos elegidos: casillas marcadas y opciones de lista con "addon"
    function addons() {
      var out = [];
      inputs.forEach(function (x) {
        if (x.inp.disabled) return;
        var type = x.f.type || 'text';
        if (type === 'check' && x.inp.checked && x.f.addon) out.push({ id: +x.f.addon, opt: propOf(x.f) });
        if (type === 'choice' && x.inp.getAttribute('data-addon')) out.push({ id: +x.inp.getAttribute('data-addon'), opt: propOf(x.f) + ': ' + x.inp.value });
        if (type === 'select') {
          var o = x.inp.options[x.inp.selectedIndex];
          if (o && o.getAttribute('data-addon')) out.push({ id: +o.getAttribute('data-addon'), opt: propOf(x.f) + ': ' + o.value });
        }
      });
      return out;
    }
    function qty() {
      var q = document.querySelector('input[name="quantity"][form="' + formId + '"]') || (form && form.querySelector('input[name="quantity"]'));
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }
    function syncFees() {
      var list = addons();
      fees.value = list.map(function (a) { return a.id + ':1'; }).join(',');
      fees.disabled = !list.length;
      return list;
    }
    var adding = false, passing = false;
    // En window (no document) para correr antes que el theme y los otros guardias de fg-pdp.js.
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[type=submit], .sticky-product-form__submit, .shopify-payment-button__button, .shopify-payment-button [role=button]');
      if (!b) return;
      var buyNow = !!b.closest('.shopify-payment-button');
      var f = b.form || (b.closest && b.closest('form'));
      // ojo: form.id puede ser el <input name="id"> de la variante, por eso getAttribute
      if (f && f.getAttribute('id') !== formId && !b.classList.contains('sticky-product-form__submit') && !buyNow) return;
      if (passing) { passing = false; return; }
      if (!valid()) { e.preventDefault(); e.stopImmediatePropagation(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var list = syncFees();
      if (!list.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (adding) return;
      adding = true;
      window.__fgpzPending = Date.now();   // el guardia no quita el cargo mientras sube el producto
      var title = ((document.querySelector('.product__title h1, h1') || {}).textContent || '').trim();
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list.map(function (a) { return { id: a.id, quantity: qty(), properties: { _pz_fee: '1', For: title + ' — ' + a.opt } }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('addon');
        if (buyNow) {
          // "Buy it now" no pasa por el carrito: se agrega el producto también y se va al checkout
          return fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
            .then(function (r2) { if (!r2.ok) throw new Error('add'); location.href = '/checkout'; });
        }
        passing = true;
        b.click();
      }).catch(function () {
        alert('Sorry, we could not add your item. Please try again.');
      }).then(function () { adding = false; });
    }, true);
    if (form) {
      form.addEventListener('submit', function (e) { if (!valid()) { e.preventDefault(); e.stopImmediatePropagation(); } else syncFees(); }, true);
      // Los campos vacíos no viajan (si no, el carrito muestra "Text above the photo:" vacío)
      form.addEventListener('formdata', function (e) {
        inputs.forEach(function (x) {
          if (x.inp.disabled) return;
          var type = x.f.type || 'text';
          var empty = type === 'file' ? !(x.inp.files && x.inp.files.length) : type === 'check' ? !x.inp.checked : !String(x.inp.value).trim();
          if (empty) e.formData.delete(x.inp.name);
        });
      });
    }
  }

  function boot() { document.querySelectorAll('fg-personalizer').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
